var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListagem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "22px",
    viewBox: "0 0 28 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "listagem") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-1394.000000, -38.000000)",
    fillRule: "nonzero",
    stroke: ""
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(1384.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "listagem",
    transform: "translate(12.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 0,
    x2: 24,
    y2: 0,
    id: "Vector",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 9,
    x2: 24,
    y2: 9,
    id: "Vector",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: 18,
    x2: 24,
    y2: 18,
    id: "Vector",
    strokeWidth: 2.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    id: "Vector",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 9,
    x2: 1,
    y2: 9,
    id: "Vector",
    strokeWidth: 3.2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 18,
    x2: 1,
    y2: 18,
    id: "Vector",
    strokeWidth: 3.2
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListagem);
export default __webpack_public_path__ + "static/media/listagem.9fd8193d818c274e3b7f5f9c3fb563b5.svg";
export { ForwardRef as ReactComponent };